import { Loader as BaseLoader } from "@rshbintech.dboul/core-ui";
import styles from "./styles.scss";

export const Loader = () => (
  <BaseLoader size="medium" className={styles.loader} />
);
